import { AbstractNode } from '@/orrm/model/index'

export class Thematique extends AbstractNode {
  protected jsonApiType = 'taxonomy_term/orrm_thematique_cartographique'
  protected static pageSize = 10

  get name (): string {
    return this.getAttribute('name')
  }
}
